import { ApplicationComponentId } from './application-component';

export enum NotificationFilterUserType {
  SUBSCRIBER = 'SUBSCRIBER', // assinante
  COMMON = 'COMMON', // normal
}

export enum NotificationStatus {
  SKETCH = 'SKETCH',
  SENT = 'SENT',
}

export enum NotificationDirectType {
  APP_AREA = 'APP_AREA',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
}

export type NotificationDirect = {
  type: NotificationDirectType;
  direct_to: ApplicationComponentId | string;
};

export type NotificationFilter = {
  age: {
    group_13_to_17: boolean;
    group_18_to_29: boolean;
    group_30_to_39: boolean;
    group_40_to_49: boolean;
  };
  gender: {
    male: boolean;
    female: boolean;
  };
};

export type Notification = {
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  description: string;
  status: NotificationStatus;
  schedule_shipping?: string;
  direct?: NotificationDirect;
  filter?: NotificationFilter;
};

export const translateNotificationStatus = (status: NotificationStatus | string): string => {
  switch (status) {
    case NotificationStatus.SKETCH:
      return 'Rascunho';
    case NotificationStatus.SENT:
      return 'Enviado';
    default:
      return status;
  }
};
